// extracted by css-extract-rspack-plugin
export default {"footer":"jmssW9mYzAM3M1YW__footer___"};